import React from 'react';
import { DillDropdown } from '../../../general/Dill';

/** A generic `<select>`-style dropdown for a configurable list of options (the DROPDOWN field
 * type). Mirrors StateDropDown.tsx, but takes its options as a prop instead of hardcoding states. */
const OptionsDropDown = ({
  options,
  errorText = '',
  label = 'Select an option',
  isRequired,
  value,
  onTextChange,
  wrapperClassName = '',
  containerClassName = 'h-[42px]',
  labelTextClassName = 'text-wrap',
}: {
  options: Array<string | { label: string; value: string }>;
  errorText?: string;
  label?: string;
  isRequired: boolean;
  value: string;
  onTextChange: (props: any) => void;
  wrapperClassName?: string;
  containerClassName?: string;
  labelTextClassName?: string;
}) => {
  // Most options are plain strings (label === value); supplier-branches/supplier-sales-reps
  // fields configured to save an ERP ID pass {label, value} pairs instead — see
  // resolveFieldOptions/resolveDropdownFieldOptions in conditionalOptionUtils.ts.
  const normalizedOptions = options.map((option) =>
    typeof option === 'string' ? { label: option, value: option } : option
  );

  return (
    <div className={`w-full ${wrapperClassName}`}>
      <DillDropdown
        isRequired={isRequired}
        label={label}
        value={value}
        errorText={errorText}
        labelTextClassName={`${labelTextClassName}`}
        containerClassName={`${containerClassName}`}
        tabToNextFieldOnClose
        items={normalizedOptions}
        onSelectChange={(item) => {
          if (item && item?.value !== null) {
            onTextChange(item.value);
          }
        }}
      />
    </div>
  );
};

export default OptionsDropDown;
